import axios from 'axios';
import routes from '../app/routes';

const prepareFormDataForSend = (values) => {
  const formData = {
    name: values.title,
  };
  return formData;
};

export const enterpriseActions = {
  loadEnterprises: (dispatch) => {
    axios.get(routes.api.enterprises.index).then((resp) => {
      dispatch({ type: 'loadEnterprises', enterprises: resp.data.data });
    });
  },
  blockEnterprise: (dispatch, enterpriseId) => {
    axios.get(routes.api.enterprises.show(enterpriseId)).then((resp) => {
      dispatch({ type: 'updateEnterprise', enterprise: resp.data.data });
    });
  },
  addEnterprise: (dispatch, values, callback) => {
    axios
      .post(routes.api.enterprises.create, {
        ...prepareFormDataForSend(values),
      })
      .then((resp) => {
        callback(resp.data.data.id);
      });
  },
  editEnterprise: (id) => {
    document.location.href = routes.api.enterprises.edit(id);
  },
};
